export const PREDICT_MARKET_ABI = [
  { inputs: [], name: 'AllreadySet', type: 'error' },
  { inputs: [], name: 'AlreadyInitialized', type: 'error' },
  { inputs: [], name: 'BettingEnded', type: 'error' },
  { inputs: [], name: 'BettingNotStarted', type: 'error' },
  { inputs: [], name: 'CycleAlreadyActive', type: 'error' },
  { inputs: [], name: 'CycleAlreadySettled', type: 'error' },
  { inputs: [], name: 'CycleNotEnded', type: 'error' },
  { inputs: [], name: 'DeadlinePassed', type: 'error' },
  { inputs: [], name: 'FeeTooHigh', type: 'error' },
  { inputs: [], name: 'InsufficientBalance', type: 'error' },
  { inputs: [], name: 'InvalidAmount', type: 'error' },
  { inputs: [], name: 'InvalidIndex', type: 'error' },
  { inputs: [], name: 'InvalidNonce', type: 'error' },
  { inputs: [], name: 'InvalidSig', type: 'error' },
  { inputs: [], name: 'InvalidTimeRange', type: 'error' },
  { inputs: [], name: 'LockerExpired', type: 'error' },
  { inputs: [], name: 'NotSettled', type: 'error' },
  { inputs: [], name: 'PredictNotOpen', type: 'error' },
  { inputs: [{ internalType: 'address', name: 'token', type: 'address' }], name: 'SafeERC20FailedOperation', type: 'error' },
  { inputs: [], name: 'Unauthorized', type: 'error' },
  { inputs: [], name: 'ZeroAddress', type: 'error' },
  {
    anonymous: false, type: 'event', name: 'CycleAdded',
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'cycleId', type: 'uint256' },
      { indexed: false, internalType: 'uint40', name: 'bettingEndTime', type: 'uint40' },
      { indexed: false, internalType: 'uint40', name: 'endTime', type: 'uint40' },
      { indexed: false, internalType: 'uint256', name: 'startPrice', type: 'uint256' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'CycleSettled',
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'cycleId', type: 'uint256' },
      { indexed: false, internalType: 'uint8', name: 'result', type: 'uint8' },
      { indexed: false, internalType: 'uint256', name: 'finalPrice', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'prizeAmount', type: 'uint256' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'OrderCreated',
    inputs: [
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: true, internalType: 'uint256', name: 'cycleId', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'orderId', type: 'uint256' },
      { indexed: false, internalType: 'uint8', name: 'direction', type: 'uint8' },
      { indexed: false, internalType: 'uint256', name: 'amount', type: 'uint256' },
      { indexed: false, internalType: 'uint256', name: 'share', type: 'uint256' },
      { indexed: false, internalType: 'bool', name: 'fromLocker', type: 'bool' },
    ],
  },
  {
    anonymous: false, type: 'event', name: 'OrderSettled',
    inputs: [
      { indexed: true, internalType: 'uint256', name: 'orderId', type: 'uint256' },
      { indexed: true, internalType: 'address', name: 'user', type: 'address' },
      { indexed: false, internalType: 'uint256', name: 'reward', type: 'uint256' },
    ],
  },
  {
    type: 'function', name: 'addCycle', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'uint40', name: 'bettingEndTime', type: 'uint40' },
      { internalType: 'uint40', name: 'endTime', type: 'uint40' },
      { internalType: 'uint40', name: 'feeRate', type: 'uint40' },
      { internalType: 'uint40', name: 'rewardRate', type: 'uint40' },
      { internalType: 'uint256', name: 'startPrice', type: 'uint256' },
    ],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'addCycleWithSignature', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'uint40', name: 'bettingEndTime', type: 'uint40' },
      { internalType: 'uint40', name: 'endTime', type: 'uint40' },
      { internalType: 'uint40', name: 'feeRate', type: 'uint40' },
      { internalType: 'uint40', name: 'rewardRate', type: 'uint40' },
      { internalType: 'uint256', name: 'startPrice', type: 'uint256' },
      { internalType: 'uint40', name: 'cycleId', type: 'uint40' },
      { internalType: 'uint256', name: 'deadline', type: 'uint256' },
      { internalType: 'bytes', name: 'signature', type: 'bytes' },
    ],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'availableBalance', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [{ internalType: 'uint256', name: 'balance', type: 'uint256' }],
  },
  {
    type: 'function', name: 'baseToken', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'betFromEOA', stateMutability: 'nonpayable',
    inputs: [{
      components: [
        { internalType: 'uint256', name: 'cycleId', type: 'uint256' },
        { internalType: 'uint256', name: 'betAmount', type: 'uint256' },
        { internalType: 'uint8', name: 'direction', type: 'uint8' },
        { internalType: 'uint256', name: 'share', type: 'uint256' },
        { internalType: 'uint256', name: 'nonce', type: 'uint256' },
        { internalType: 'uint256', name: 'deadline', type: 'uint256' },
        { internalType: 'bytes', name: 'betSignature', type: 'bytes' },
      ],
      internalType: 'struct IPredictMarket.BetParams', name: 'params', type: 'tuple',
    }],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'betFromLocker', stateMutability: 'nonpayable',
    inputs: [
      {
        components: [
          { internalType: 'uint256', name: 'cycleId', type: 'uint256' },
          { internalType: 'uint256', name: 'betAmount', type: 'uint256' },
          { internalType: 'uint8', name: 'direction', type: 'uint8' },
          { internalType: 'uint256', name: 'share', type: 'uint256' },
          { internalType: 'uint256', name: 'nonce', type: 'uint256' },
          { internalType: 'uint256', name: 'deadline', type: 'uint256' },
          { internalType: 'bytes', name: 'betSignature', type: 'bytes' },
        ],
        internalType: 'struct IPredictMarket.BetParams', name: 'params', type: 'tuple',
      },
      { internalType: 'uint256', name: 'transferAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'transferNonce', type: 'uint256' },
      { internalType: 'uint256', name: 'transferDeadline', type: 'uint256' },
      { internalType: 'bytes', name: 'transferSignature', type: 'bytes' },
    ],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'cycles', stateMutability: 'view',
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    outputs: [
      { internalType: 'uint40', name: 'startTime', type: 'uint40' },
      { internalType: 'uint40', name: 'bettingEndTime', type: 'uint40' },
      { internalType: 'uint40', name: 'endTime', type: 'uint40' },
      { internalType: 'uint40', name: 'feeRate', type: 'uint40' },
      { internalType: 'uint40', name: 'rewardRate', type: 'uint40' },
      { internalType: 'bool', name: 'isSettled', type: 'bool' },
      { internalType: 'uint256', name: 'startPrice', type: 'uint256' },
      { internalType: 'uint256', name: 'totalUpAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'totalDownAmount', type: 'uint256' },
      { internalType: 'uint256', name: 'totalUpShare', type: 'uint256' },
      { internalType: 'uint256', name: 'totalDownShare', type: 'uint256' },
      { internalType: 'uint256', name: 'finalPrice', type: 'uint256' },
      { internalType: 'uint256', name: 'prizeAmount', type: 'uint256' },
      { internalType: 'uint8', name: 'result', type: 'uint8' },
    ],
  },
  {
    type: 'function', name: 'factory', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'initialize', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'address', name: '_factory', type: 'address' },
      { internalType: 'address', name: '_baseToken', type: 'address' },
      { internalType: 'address', name: '_quoteToken', type: 'address' },
    ],
    outputs: [],
  },
  {
    type: 'function', name: 'locker', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'nextCycleId', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
  },
  {
    type: 'function', name: 'orders', stateMutability: 'view',
    inputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
    outputs: [
      { internalType: 'address', name: 'user', type: 'address' },
      { internalType: 'uint256', name: 'cycleId', type: 'uint256' },
      { internalType: 'uint256', name: 'amount', type: 'uint256' },
      { internalType: 'uint8', name: 'direction', type: 'uint8' },
      { internalType: 'uint256', name: 'share', type: 'uint256' },
      { internalType: 'uint256', name: 'timestamp', type: 'uint256' },
      { internalType: 'bool', name: 'isSettled', type: 'bool' },
      { internalType: 'uint8', name: 'balanceFrom', type: 'uint8' },
    ],
  },
  {
    type: 'function', name: 'quoteToken', stateMutability: 'view',
    inputs: [],
    outputs: [{ internalType: 'address', name: '', type: 'address' }],
  },
  {
    type: 'function', name: 'setLocker', stateMutability: 'nonpayable',
    inputs: [{ internalType: 'address', name: 'lockerAddress', type: 'address' }],
    outputs: [],
  },
  {
    type: 'function', name: 'settleCycle', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'uint256', name: 'cycleId', type: 'uint256' },
      { internalType: 'uint256', name: 'price', type: 'uint256' },
    ],
    outputs: [],
  },
  // V2: Settle ALL unsettled orders for user (1-arg overload — primary usage)
  {
    type: 'function', name: 'settleOrders', stateMutability: 'nonpayable',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [],
  },
  // V2: Settle specific orders by IDs (2-arg overload)
  {
    type: 'function', name: 'settleOrders', stateMutability: 'nonpayable',
    inputs: [
      { internalType: 'address', name: 'user', type: 'address' },
      { internalType: 'uint256[]', name: 'orderIds', type: 'uint256[]' },
    ],
    outputs: [],
  },
  // V2: Get all unsettled order IDs for a user
  {
    type: 'function', name: 'unsettledOrderIds', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [{ internalType: 'uint256[]', name: '', type: 'uint256[]' }],
  },
  {
    type: 'function', name: 'userNonces', stateMutability: 'view',
    inputs: [{ internalType: 'address', name: 'user', type: 'address' }],
    outputs: [{ internalType: 'uint256', name: 'nonce', type: 'uint256' }],
  },
] as const;
